import {Component, Input} from '@angular/core';

@Component({
  selector: 'package-rule-detail',
  templateUrl: './package-rule-detail.component.html',
  // inputs: [ 'rule' ]
})

/**
 * This component has no interactions; it merely displays the card preview of a rule.
 */
export class PackageRuleDetailComponent {
  @Input() rule: any;
}
